import { CommonError } from "lego-gui-lib";
import {
  RemoteChildDataSource,
  RemoteChildDataSourceOptions
} from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { RemoteListChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteListChildDataSource";
import { RemoteOneChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteOneChildDataSource";
import { action, observable } from "mobx";
import { ReactText } from "react";
import { ConnectionDef } from "./schema";

export class ConnectionDataSource<T, ID> extends RemoteChildDataSource<T, ID> {
  @observable public oneDataSource: ConnectionOneDataSource<T, ID>;
  @observable public listDataSource: ConnectionListDataSource<T, ID>;

  public constructor(options: RemoteChildDataSourceOptions) {
    super(options);
    this.listDataSource = new ConnectionListDataSource<T, ID>(options);
    this.oneDataSource = new ConnectionOneDataSource<T, ID>({ ...options });
  }

  @action
  public async deleteConnection(connectionId: ReactText): Promise<void> {
    try {
      await this.api.delete(`${this.oneDataSource.url}/${connectionId}`);
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
  }

  @action
  public async saveConnection(
    newConnection: ConnectionDef
  ): Promise<ConnectionDef> {
    let resp = {} as ConnectionDef;
    try {
      resp = await this.api.save(`${this.oneDataSource.url}`, newConnection);
    } catch (e) {
      this.commons.newError(e.response.data as CommonError);
    }
    return resp;
  }
}

export class ConnectionOneDataSource<T, ID> extends RemoteOneChildDataSource<
  T,
  ID
> {}

export class ConnectionListDataSource<T, ID> extends RemoteListChildDataSource<
  T,
  ID
> {}
